import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  background-color: #f6f6f6;
  border-radius: 8px 8px 0 0;
  padding: 1rem;
`
export const Content = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  flex-direction: row;
  gap: 3rem;
  padding: 1rem;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
export const FileSelected = styled.li`
  user-select: none;
  position: relative;
  list-style: none;
  display: flex;
  height: 100%;
  min-width: 500px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  border-radius: 8px;
  background-color: #e8e8e8;
  .action--file{
    position: absolute;
    display: flex;
    z-index: 9;
    top: 0px;
    right: -27px;
    gap: 0.5rem;
    padding: 0.3rem;
    justify-content: space-around;
    align-items: center;
    font-size: 1.5rem;
    border-radius: 4px;
    background-color: #e8e8e8;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    span {
      width: 2px;
      height: 20px;
      background-color: #919191;
      margin: 0 0.5rem;
    }
    .link--{
      color: #919191;
      cursor: pointer;
    }
    .trash--{
      color: #ff0001;
      cursor: pointer;
    }
    .disabled--{
      pointer-events: none;
      opacity: 0.3;
    }
  }
`